import type { HTMLAttributes } from "react";

type OpeningOrientationSquareProps = {
  orientation: "white" | "black" | null;
} & Pick<HTMLAttributes<HTMLSpanElement>, "className">;

export default function OpeningOrientationSquare({
  orientation,
  className,
}: OpeningOrientationSquareProps) {
  const displayOrientation = orientation === "black" ? "black" : "white";
  const squareClassName =
    displayOrientation === "black"
      ? "inline-block size-4 shrink-0 rounded-sm border border-slate-200 bg-black"
      : "inline-block size-4 shrink-0 rounded-sm border border-slate-700 bg-white";

  return (
    <span
      data-testid="opening-orientation-square"
      data-orientation-display={displayOrientation}
      aria-hidden="true"
      className={`${squareClassName} ${className ?? ""}`.trim()}
    />
  );
}
